import styled from 'styled-components'

export const Overlay = styled.div`
  min-height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
